import { render, staticRenderFns } from "./SimpleChoiceHorizontalWithDependency.vue?vue&type=template&id=0ecc2f38&scoped=true"
import script from "./SimpleChoiceHorizontalWithDependency.vue?vue&type=script&lang=js"
export * from "./SimpleChoiceHorizontalWithDependency.vue?vue&type=script&lang=js"
import style0 from "./SimpleChoiceHorizontalWithDependency.vue?vue&type=style&index=0&id=0ecc2f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc2f38",
  null
  
)

export default component.exports